import { Grid, Popover } from '@material-ui/core';
import {
  Button,
  Card,
  Checkbox,
  FormControlLabel,
  Icons,
  Typography,
} from '@nutrien/cxp-components';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import { Subscription } from 'rxjs';

import { useMst } from '../../mobx-models/Root';
import { Discipline, InspectionTaskListType, ITaskWiseComments } from '../../models/models';
import { usePreviousTaskComments } from '../../rxdb/previousTaskComments/usePreviousTaskComments';
import type { TaskList } from '../../rxdb/taskList/taskList.types';
import type { ViewInspectorDocument } from '../../rxdb/viewInspector/viewInspector.types';
import { useOnlineStatus } from '../../utilities/useOnlineStatus';
import { TaskStatus } from '../../utilities/enums';
import { useWindowDimensions } from '../../utilities/useWindowDimensions';
import {
  checkInspectionStatusForUpdate,
  checkTaskStatusForReAssign,
  createObjectForBulkReAssignAndSign,
  getStatus,
  getStatusForInspection,
  getValueFromLocalStorage,
  setValueinLocalStorage,
} from '../../utilities/utilityFunctions';
import AdhocInspectionAssignment from '../AssignInspector/AdhocInspectionAssignment';
import AssignInspector from '../AssignInspector/AssignInspector';
import ReAssignInspector from '../AssignInspector/ReAssignInspector';
import CommentToolTip from '../CommentToolTip';
import DeleteTask from '../DeleteTask';
import OfflineDialog from '../OfflineDialog';
import StatusLabel from '../StatusLabel/StatusLabel';
import useStyles from './OnGoing.styles';
interface Props {
  inspection: InspectionTaskListType;
  inspectorData: ViewInspectorDocument[];
  renderAccordian: (
    id: string,
    statusId: number,
    label: React.ReactElement,
    content: (false | JSX.Element)[] | undefined,
  ) => JSX.Element;
  isAssignToLead: boolean;
}

const OnGoing: React.FC<Props> = ({
  inspection,
  inspectorData,
  renderAccordian,
  isAssignToLead,
}) => {
  const size = useWindowDimensions();
  const { HandleGesture, CurrentUserSelected, WorkPackageTabs, SiteDiscipline } = useMst();
  const portrait = size.height > size.width;
  const classes = useStyles({ portrait });
  const history = useHistory();
  const online = useOnlineStatus();
  const { assignBackComment, previousTaskCommentsCollection, previousTaskCommentsInitialized } =
    usePreviousTaskComments();

  const [openReAssignInspector, setOpenReAssignInspector] = useState<boolean>(false);
  const [taskDeletionConfirmationOpen, setTaskDeletionConfirmationOpen] = useState<boolean>(false);
  const [taskId, setTaskId] = useState<number>(0);
  const [isTaskDeletion, setIsTaskDeletion] = useState<boolean>(false);
  const [openUpdateInspector, setOpenUpdateInspector] = useState<boolean>(false);
  const [inspectionID, setInspectionID] = useState<number>(0);
  const [deleteTaskData, setDeleteTaskData] = useState<TaskList>();
  const [inspectionLevelComment, setInspectionLevelComment] = useState<string>('');
  const [timeOutId, setTimeoutId] = useState<NodeJS.Timeout | null | number>(-1);
  const [midId, setMidId] = useState<number>(0);
  const [onHold, setOnHold] = useState<boolean>(false);
  const [actionAnchorEl, setActionAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [taskWiseCommentData, setTaskWiseCommentData] = useState<ITaskWiseComments>({});
  const [offlineDialogBox, setOfflineDialogBox] = useState<boolean>(false);
  const [isOpenAdhocReAssignInspector, setIsOpenAdhocReAssignInspector] = useState(false);
  const [isActionPopoverOpen, setIsActionPopoverOpen] = useState(false);

  const currentInspectorId = CurrentUserSelected?.currentUser?.inspectorId;
  const {
    assetName,
    assetId,
    areaId,
    inspectionId,
    inspectorId,
    areaList,
    inspectionAssignmentComment,
    assetInspectionType,
    assetInspectionStatusId,
    isAssignedBackTask,
    taskList,
    workPackageId,
    isAdhoc,
  } = inspection;

  const getTaskCommentsFromRxdb = async () => {
    for (const task in taskList) {
      if (
        taskList[Number(task)]?.fkInspectionTaskStatusCategory < TaskStatus.FI_SIGN_PENDING &&
        taskList[Number(task)]?.fkInspectionTaskStatusCategory !== TaskStatus.COMPLETED
      ) {
        const taskCommentsDocument = await assignBackComment(
          taskList[Number(task)]?.pkAssetInspectionTask,
        );
        if (taskCommentsDocument?.length) {
          const obj2: ITaskWiseComments = {};
          obj2[taskCommentsDocument[0].fkAssetInspectionTask] = {
            comment: taskCommentsDocument[0].comment,
            attentionFlag: taskCommentsDocument[0].attentionFlag,
          };
          setTaskWiseCommentData((curr: ITaskWiseComments) => {
            return { ...curr, ...obj2 };
          });
        }
      }
    }
  };

  const checkforInspection = () => {
    if (HandleGesture.gestureForReAssign) {
      if (
        taskList
          ?.filter((task: TaskList) => task.fkInspectionTaskStatusCategory !== TaskStatus.COMPLETED)
          .every((task: TaskList) => HandleGesture.taskIds.includes(task.pkAssetInspectionTask))
      ) {
        HandleGesture.insertIntoInspectionId(Number(inspectionId));
      } else {
        HandleGesture.removeFromInspectionId(Number(inspectionId));
      }
    }
  };

  const isTaskEnableForReAssign = (taskStatusId: number) => taskStatusId !== TaskStatus.COMPLETED;

  const checkforTask = (insert: boolean) => {
    if (HandleGesture.gestureForReAssign) {
      taskList?.forEach((task: TaskList) => {
        if (task.fkInspectionTaskStatusCategory !== TaskStatus.COMPLETED) {
          if (insert) {
            HandleGesture.insertIntoAccordion(String(task.fkAssetInspection));
            HandleGesture.insertIntoTaskId(Number(task.pkAssetInspectionTask));
            HandleGesture.setTasksForReAssignAndSign(
              createObjectForBulkReAssignAndSign(task, assetInspectionStatusId),
              true,
            );
          } else {
            HandleGesture.removeFromTaskId(Number(task.pkAssetInspectionTask));
            HandleGesture.setTasksForReAssignAndSign(
              createObjectForBulkReAssignAndSign(task, assetInspectionStatusId),
              false,
            );
          }
        }
      });
    }
  };

  const handleInspectionCheckBoxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = event.target;
    if (checked) {
      HandleGesture.insertIntoInspectionId(Number(inspectionId));
      checkforTask(checked);
    } else {
      HandleGesture.removeFromInspectionId(Number(inspectionId));
      checkforTask(checked);
    }
    event.stopPropagation();
  };

  const setValuesInMobX = (task: TaskList) => {
    setOnHold(true);
    HandleGesture.insertIntoAccordion(String(task.fkAssetInspection));
    HandleGesture.insertIntoTaskId(task.pkAssetInspectionTask);
    HandleGesture.setTasksForReAssignAndSign(
      createObjectForBulkReAssignAndSign(task, assetInspectionStatusId),
      true,
    );

    HandleGesture.setInspectionStatusId(assetInspectionStatusId);
    checkforInspection();
  };

  const onPress = (task: TaskList) => {
    setMidId(task.pkAssetInspectionTask);
    if (!HandleGesture.bulkUpload) {
      const tid: NodeJS.Timeout | null = setTimeout(() => {
        if (isTaskEnableForReAssign(task.fkInspectionTaskStatusCategory) && !isActionPopoverOpen) {
          HandleGesture.setGestureForReAssign(true);
          setValuesInMobX(task);
        }
      }, 1000);
      setTimeoutId(tid);
    }
  };

  const handleTaskClick = (task: TaskList) => {
    const {
      pkAssetInspectionTask,
      fkInspectorField,
      fkInspectorLead,
      fkInspectionTaskStatusCategory,
    } = task;
    setValueinLocalStorage(
      'assetId',
      SiteDiscipline.disciplineId === Discipline.Shaft ? areaId : assetId,
    );
    setValueinLocalStorage('inspectionID', inspectionId);
    setValueinLocalStorage('inspectorId', inspectorId);
    setValueinLocalStorage('taskId', String(pkAssetInspectionTask));
    CurrentUserSelected.setInspectionId(Number(inspectionId));
    CurrentUserSelected.setTaskId(pkAssetInspectionTask);
    CurrentUserSelected.setIsAdhoc(isAdhoc || false);
    CurrentUserSelected.setAssetId(
      SiteDiscipline.disciplineId === Discipline.Shaft ? areaId : assetId,
    );
    setValueinLocalStorage('taskFieldInspectorId', String(fkInspectorField));
    setValueinLocalStorage('taskLeadInspectorId', String(fkInspectorLead));
    setValueinLocalStorage('taskStatus', String(fkInspectionTaskStatusCategory));
    setValueinLocalStorage('inspectionStatus', assetInspectionStatusId);
    setValueinLocalStorage('isAdhoc', isAdhoc);
    if (isAdhoc) {
      setValueinLocalStorage('workPackageId', String(workPackageId));
      CurrentUserSelected.setWorkPackageId(workPackageId);
    }

    if (
      fkInspectorField === currentInspectorId &&
      fkInspectionTaskStatusCategory === TaskStatus.FI_SIGN_PENDING
    )
      history.push('/complete-inspection');
    else history.push('/inspection-details');
  };

  const handleReAssign = (e: { stopPropagation: () => void }, tId: number) => {
    e.stopPropagation();
    if (online) {
      setTaskId(tId);
      setActionAnchorEl(null);
      if (WorkPackageTabs.tab === 1) setIsOpenAdhocReAssignInspector(true);
      else setOpenReAssignInspector(true);
    } else {
      setActionAnchorEl(null);
      setOfflineDialogBox(true);
    }
  };

  const handleUpdateInspectors = (e: { stopPropagation: () => void }, tId: number) => {
    e.stopPropagation();
    if (online) {
      if (tId) {
        setTaskId(tId);
      }
      setInspectionID(Number(inspectionId));
      setInspectionLevelComment(inspectionAssignmentComment || '');
      setActionAnchorEl(null);
      setOpenUpdateInspector(true);
    } else {
      setActionAnchorEl(null);
      setOfflineDialogBox(true);
    }
  };

  const handleDeleteTask = (
    e: { stopPropagation: () => void },
    taskData: TaskList,
    val: boolean,
  ) => {
    setDeleteTaskData(taskData);
    setTaskDeletionConfirmationOpen(true);
    setIsTaskDeletion(val);
    e.stopPropagation();
  };

  const openActionMenu = (
    event: React.TouchEvent<HTMLButtonElement> | React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setIsActionPopoverOpen(true);
    setActionAnchorEl(event.currentTarget);
    event.stopPropagation();
  };

  const handleActionClose = (e: { stopPropagation: () => void }) => {
    setActionAnchorEl(null);
    setIsActionPopoverOpen(false);
    e.stopPropagation();
  };

  const onClickUp = (task: TaskList) => {
    if (
      HandleGesture.bulkUpload &&
      midId === Number(task.pkAssetInspectionTask) &&
      isTaskEnableForReAssign(task.fkInspectionTaskStatusCategory)
    ) {
      if (HandleGesture.taskIds.includes(task.pkAssetInspectionTask)) {
        HandleGesture.removeFromTaskId(Number(task.pkAssetInspectionTask));
        HandleGesture.setTasksForReAssignAndSign(
          createObjectForBulkReAssignAndSign(task, assetInspectionStatusId),
          false,
        );
      } else {
        HandleGesture.insertIntoAccordion(String(task.fkAssetInspection));
        HandleGesture.insertIntoTaskId(Number(task.pkAssetInspectionTask));
        HandleGesture.setTasksForReAssignAndSign(
          createObjectForBulkReAssignAndSign(task, assetInspectionStatusId),
          true,
        );
      }
      checkforInspection();
    }
    if (!HandleGesture.bulkUpload) {
      clearTimeout(timeOutId as NodeJS.Timeout);
      if (midId === Number(task.pkAssetInspectionTask)) {
        handleTaskClick(task);
      }
    }
  };

  const onRelease = (e: React.TouchEvent<HTMLDivElement>, task: TaskList) => {
    onClickUp(task);
    e.preventDefault();
  };

  const showTask = (task: TaskList) =>
    !HandleGesture.bulkUpload || task.fkInspectionTaskStatusCategory !== TaskStatus.COMPLETED;
  const MainInspectionGrid = (dropDown: boolean) => {
    return (
      <Grid item container xs={12} alignItems="center">
        <Grid item xs={6} className={classes.grid1}>
          {HandleGesture.bulkUpload && (
            <Grid
              item
              onMouseUp={e => {
                e.stopPropagation();
              }}
              className={classes.checkbox}
            >
              <FormControlLabel
                control={
                  <Checkbox
                    data-testid="multiselect-checkbox-ongoing"
                    checked={HandleGesture.inspectionIds.includes(Number(inspectionId))}
                    onChange={handleInspectionCheckBoxClick}
                  />
                }
                label=""
              />
            </Grid>
          )}
          <Grid item className={classes.inspectionDetails}>
            <Typography variant="h5" display="inline">
              {`Id: ${inspectionId} - ${assetName}`}
            </Typography>
            <Typography className={classes.greenDot} />
            <Typography
              display="inline"
              fontWeight="normal"
              variant="h5"
              className={classes.locationStyle}
            >
              {areaList?.length > 0 ? areaList[0]?.name : ''}
            </Typography>
            {!dropDown &&
              (taskList as TaskList[])[0]?.fkInspectionTaskStatusCategory <
                TaskStatus.FI_SIGN_PENDING &&
              (taskList as TaskList[])[0]?.fkInspectionTaskStatusCategory !==
                TaskStatus.COMPLETED && (
                <CommentToolTip
                  comment={
                    taskWiseCommentData[(taskList as TaskList[])[0]?.pkAssetInspectionTask]?.comment
                  }
                  attentionFlag={
                    taskWiseCommentData[(taskList as TaskList[])[0]?.pkAssetInspectionTask]
                      ?.attentionFlag
                  }
                />
              )}
            {inspectionAssignmentComment && (
              <Typography variant="subtitle2" fontWeight="normal">
                {inspectionAssignmentComment}
              </Typography>
            )}
            <Typography variant="subtitle2" fontWeight="normal" className={classes.locationStyle}>
              {assetInspectionType}
              <Typography className={`${classes.greenDot}`} />
              {taskList &&
                (!dropDown
                  ? `LI: ${taskList[0]?.leadInspectorName || ''}, ${
                      taskList[0]?.name ? 'FI: ' : 'DEC: '
                    }
                      ${taskList[0]?.name || taskList[0]?.clerkName || ''}`
                  : `LI: ${taskList[0]?.leadInspectorName || ''}`)}
            </Typography>
          </Grid>
        </Grid>
        {checkInspectionStatusForUpdate(assetInspectionStatusId) && isAssignToLead && dropDown && (
          <Grid item xs={2} className={classes.statusAndButtons}>
            {!HandleGesture.gestureForReAssign && (
              <Grid
                className={classes.updateBtnGrid}
                container
                justifyContent="flex-end"
                alignItems="flex-end"
              >
                <Button
                  color="primary"
                  className="updateBtn"
                  noMinHeight
                  onMouseUp={handleUpdateInspectors}
                  onMouseDown={e => e.stopPropagation()}
                  onTouchStart={e => e.stopPropagation()}
                  onTouchEnd={e => {
                    handleUpdateInspectors(e);
                    e.preventDefault();
                  }}
                >
                  <Typography variant="subtitle2">Update Inspectors</Typography>
                </Button>
              </Grid>
            )}
          </Grid>
        )}
        {checkInspectionStatusForUpdate(assetInspectionStatusId) && isAssignToLead && !dropDown && (
          <>
            <Grid item xs={2} className={classes.statusAndButtons}>
              {!HandleGesture.gestureForReAssign && (
                <Grid
                  className={classes.assignButtonGrid}
                  container
                  justifyContent="flex-end"
                  alignItems="flex-end"
                >
                  <Button
                    data-testid="ongoing-action-button"
                    color="primary"
                    className="assignButton"
                    noMinHeight
                    onMouseUp={e => openActionMenu(e)}
                    onMouseDown={e => e.stopPropagation()}
                    onTouchStart={e => e.stopPropagation()}
                    onTouchEnd={e => {
                      openActionMenu(e);
                      e.preventDefault();
                    }}
                    endAdornment={<Icons.ChevronDownFeather color="primary" size="small" />}
                  >
                    <Typography variant="subtitle2">Action</Typography>
                  </Button>
                </Grid>
              )}
            </Grid>
            <Popover
              id="action"
              open={Boolean(actionAnchorEl)}
              anchorEl={actionAnchorEl}
              onClose={handleActionClose}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'center',
              }}
              classes={{ paper: classes.paper }}
            >
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <Grid
                    container
                    className={classes.button}
                    onMouseUp={e => {
                      if ((taskList as TaskList[])[0]?.clerkId) {
                        handleUpdateInspectors(
                          e,
                          (taskList as TaskList[])[0]?.pkAssetInspectionTask,
                        );
                      } else {
                        handleReAssign(e, (taskList as TaskList[])[0]?.pkAssetInspectionTask);
                      }
                    }}
                    onMouseDown={e => e.stopPropagation()}
                    onTouchStart={e => e.stopPropagation()}
                    onTouchEnd={e => {
                      if ((taskList as TaskList[])[0]?.clerkId) {
                        handleUpdateInspectors(
                          e,
                          (taskList as TaskList[])[0]?.pkAssetInspectionTask,
                        );
                      } else {
                        handleReAssign(e, (taskList as TaskList[])[0]?.pkAssetInspectionTask);
                      }
                      e.preventDefault();
                    }}
                  >
                    <Typography data-testid="re-assign-ongoing" variant="subtitle2">
                      Re-Assign
                    </Typography>
                  </Grid>
                </Grid>
                {!(taskList as TaskList[])[0]?.clerkId && (
                  <Grid item xs={12}>
                    <Grid
                      container
                      className={classes.button}
                      onMouseUp={handleUpdateInspectors}
                      onMouseDown={e => e.stopPropagation()}
                      onTouchStart={e => e.stopPropagation()}
                      onTouchEnd={e => {
                        handleUpdateInspectors(e);
                        e.preventDefault();
                      }}
                    >
                      <Typography data-testid="update-inspector-ongoing" variant="subtitle2">
                        Update Inspectors
                      </Typography>
                    </Grid>
                  </Grid>
                )}
                <Grid item xs={12}>
                  <Grid
                    container
                    className={classes.button}
                    onMouseUp={e => handleDeleteTask(e, (taskList as TaskList[])[0], false)}
                    onMouseDown={e => e.stopPropagation()}
                    onTouchStart={e => e.stopPropagation()}
                    onTouchEnd={e => {
                      handleDeleteTask(e, (taskList as TaskList[])[0], false);
                      e.preventDefault();
                    }}
                  >
                    <Typography data-testid="delete-task-ongoing" variant="subtitle2" color="error">
                      Delete Inspection
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Popover>
          </>
        )}
        {checkInspectionStatusForUpdate(assetInspectionStatusId) &&
          !isAssignToLead &&
          !dropDown && (
            <Grid item xs={2} className={classes.statusAndButtons}>
              <Grid container alignItems="flex-end" justifyContent="flex-end">
                <div className={classes.reAssignButtonForFI}>
                  {!HandleGesture.gestureForReAssign && (
                    <Button
                      color="primary"
                      className="reAssignButton"
                      noMinHeight
                      onMouseUp={e => {
                        handleReAssign(e, (taskList as TaskList[])[0]?.pkAssetInspectionTask);
                      }}
                      onMouseDown={e => e.stopPropagation()}
                      onTouchStart={e => e.stopPropagation()}
                      onTouchEnd={e => {
                        handleReAssign(e, (taskList as TaskList[])[0]?.pkAssetInspectionTask);
                        e.preventDefault();
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        data-testid={`re-assign-ongoing2-${
                          (taskList as TaskList[])[0]?.pkAssetInspectionTask
                        }`}
                      >
                        Re-Assign
                      </Typography>
                    </Button>
                  )}
                </div>
              </Grid>
            </Grid>
          )}
        {checkInspectionStatusForUpdate(assetInspectionStatusId) && !isAssignToLead && dropDown && (
          <Grid item xs={2} className={classes.statusAndButtons} />
        )}
        <Grid item xs={4} className={classes.statusAndButtons}>
          <Grid container justifyContent="flex-end" alignItems="center">
            <Grid item>
              <StatusLabel
                inspectionStatusId={assetInspectionStatusId}
                customClass="singleStatusStyleOnGoing"
                label={getStatusForInspection(assetInspectionStatusId)}
              />
              {isAssignedBackTask ? (
                <Grid className={classes.assignedBackGrid}>
                  <Typography variant="subtitle1" color="error">
                    Assigned back with Review findings
                  </Typography>
                </Grid>
              ) : (
                ''
              )}
            </Grid>
            {!dropDown && <Icons.ChevronRightFeather color="primary" />}
          </Grid>
        </Grid>
      </Grid>
    );
  };

  useEffect(() => {
    let pcSub: Subscription;
    if (taskList?.length && previousTaskCommentsInitialized) {
      getTaskCommentsFromRxdb();
      if (previousTaskCommentsCollection) {
        pcSub = previousTaskCommentsCollection.$.subscribe(() => {
          getTaskCommentsFromRxdb();
        });
      }
    }
    return () => {
      if (pcSub && pcSub.unsubscribe) pcSub.unsubscribe();
    };
  }, [previousTaskCommentsInitialized, taskList]);

  return (
    <>
      {taskList && taskList?.length < 2 ? (
        <Grid className={classes.outerGrid}>
          <Card
            data-testid="inspection-div-ongoing"
            elevation={1}
            className={
              HandleGesture.inspectionIds.find(id => id === Number(inspectionId)) !== undefined
                ? 'outerCardSelected'
                : classes.outerCard
            }
            onMouseDown={() => onPress((taskList as TaskList[])[0])}
            onMouseMove={() => setMidId(-1)}
            onMouseUp={e => {
              const task = (taskList as TaskList[])[0];
              if (task?.pkAssetInspectionTask) setMidId(task.pkAssetInspectionTask);
              if (onHold) setOnHold(false);
              else if (isActionPopoverOpen) handleActionClose(e);
              else onClickUp(task);
            }}
            onTouchStart={() => onPress((taskList as TaskList[])[0])}
            onTouchMove={() => setMidId(-1)}
            onTouchEnd={e => {
              if (onHold) setOnHold(false);
              else onRelease(e, (taskList as TaskList[])[0]);
            }}
          >
            <Grid className={classes.pointer1}>{MainInspectionGrid(false)}</Grid>
          </Card>
        </Grid>
      ) : (
        <Grid className={classes.cardOuterGrid}>
          <Card
            data-testid="inspection-div-ongoing"
            elevation={1}
            className={
              !HandleGesture.handleAccordion.includes(inspectionId) &&
              HandleGesture.inspectionIds.includes(Number(inspectionId))
                ? 'cardCollapsedBG'
                : ''
            }
          >
            <Grid className={classes.accordionOuterGrid}>
              {renderAccordian(
                inspectionId,
                assetInspectionStatusId,
                MainInspectionGrid(true),
                taskList?.filter(showTask)?.map((task: TaskList) => {
                  return (
                    <Card
                      key={String(task.pkAssetInspectionTask)}
                      elevation={1}
                      className={
                        HandleGesture.taskIds.includes(task.pkAssetInspectionTask)
                          ? 'taskOuterGridSelected'
                          : 'taskOuterGrid'
                      }
                      onMouseDown={() => onPress(task)}
                      onMouseMove={() => setMidId(-1)}
                      onMouseUp={() => {
                        if (task?.pkAssetInspectionTask) setMidId(task.pkAssetInspectionTask);
                        if (onHold) setOnHold(false);
                        else onClickUp(task);
                      }}
                      onTouchStart={() => onPress(task)}
                      onTouchMove={() => setMidId(-1)}
                      onTouchEnd={e => {
                        if (onHold) setOnHold(false);
                        else onRelease(e, task);
                      }}
                    >
                      <Grid className={classes.pointer}>
                        <Grid item container xs={12} alignItems="center">
                          <Grid item xs={6} className={classes.grid1}>
                            {HandleGesture.bulkUpload && (
                              <Grid item className={classes.taskCheckbox}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={HandleGesture.taskIds.includes(
                                        Number(task.pkAssetInspectionTask),
                                      )}
                                    />
                                  }
                                  label=""
                                />
                              </Grid>
                            )}
                            <Grid item className={classes.inspectionDetails}>
                              <Typography variant="h6" display="inline">
                                {`Task Id: ${task?.pkAssetInspectionTask}`}
                              </Typography>
                              {task?.fkInspectionTaskStatusCategory < TaskStatus.FI_SIGN_PENDING &&
                                task?.fkInspectionTaskStatusCategory !== TaskStatus.COMPLETED && (
                                  <CommentToolTip
                                    data-testid="assignback-comments"
                                    comment={
                                      taskWiseCommentData[task?.pkAssetInspectionTask]?.comment
                                    }
                                    attentionFlag={
                                      taskWiseCommentData[task?.pkAssetInspectionTask]
                                        ?.attentionFlag
                                    }
                                  />
                                )}
                              <Typography
                                variant="subtitle2"
                                fontWeight="normal"
                                className={classes.locationStyle}
                              >
                                {task.taskDescription}
                              </Typography>
                              <Typography
                                variant="subtitle2"
                                fontWeight="normal"
                                className={classes.locationStyle}
                              >
                                {`${task?.name ? 'FI: ' : 'DEC: '} ${
                                  task?.name || task?.clerkName || ''
                                }`}
                              </Typography>
                            </Grid>
                          </Grid>
                          <Grid item xs={2} className={classes.statusAndButtons}>
                            {!HandleGesture.gestureForReAssign &&
                              checkTaskStatusForReAssign(task?.fkInspectionTaskStatusCategory) && (
                                <Grid container alignItems="flex-end" justifyContent="flex-end">
                                  <div className={classes.reAssignButtonForFI}>
                                    <Button
                                      color="primary"
                                      className="reAssignButton"
                                      noMinHeight
                                      onMouseUp={e => {
                                        handleReAssign(e, task.pkAssetInspectionTask);
                                      }}
                                      onMouseDown={e => e.stopPropagation()}
                                      onTouchStart={e => e.stopPropagation()}
                                      onTouchEnd={e => {
                                        handleReAssign(e, task.pkAssetInspectionTask);
                                        e.preventDefault();
                                      }}
                                    >
                                      <Typography variant="subtitle2">Re-Assign</Typography>
                                    </Button>
                                  </div>
                                </Grid>
                              )}
                          </Grid>
                          <Grid container justifyContent="flex-end" alignItems="center" item xs={4}>
                            <Grid container justifyContent="flex-end" alignItems="center">
                              <Grid item className={classes.statusAndButtons}>
                                <StatusLabel
                                  taskStatusId={task.fkInspectionTaskStatusCategory}
                                  customClass={
                                    checkTaskStatusForReAssign(
                                      task.fkInspectionTaskStatusCategory,
                                    ) &&
                                    isAssignToLead &&
                                    !HandleGesture.gestureForReAssign
                                      ? 'statusStyleOnGoing'
                                      : 'reAssignButtonRemovalOnGoing'
                                  }
                                  label={getStatus(task.fkInspectionTaskStatusCategory)}
                                />
                              </Grid>
                              {checkTaskStatusForReAssign(task.fkInspectionTaskStatusCategory) &&
                                isAssignToLead && (
                                  <Grid
                                    item
                                    onMouseUp={e => {
                                      handleDeleteTask(e, task, true);
                                    }}
                                    onMouseDown={e => e.stopPropagation()}
                                    onTouchStart={e => e.stopPropagation()}
                                    onTouchEnd={e => {
                                      handleDeleteTask(e, task, true);
                                      e.preventDefault();
                                    }}
                                    className={
                                      !HandleGesture.gestureForReAssign
                                        ? classes.trashIcon
                                        : classes.trashIconRemoval
                                    }
                                  >
                                    <Icons.Trash2Feather color="error" />
                                  </Grid>
                                )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Card>
                  );
                }),
              )}
            </Grid>
          </Card>
        </Grid>
      )}

      {openReAssignInspector && (
        <ReAssignInspector
          openAssignInspector={openReAssignInspector}
          setOpenAssignInspector={setOpenReAssignInspector}
          taskId={taskId}
          workPackageId={workPackageId}
        />
      )}

      {taskDeletionConfirmationOpen && (
        <DeleteTask
          open={taskDeletionConfirmationOpen}
          onClose={() => setTaskDeletionConfirmationOpen(false)}
          taskData={deleteTaskData as TaskList}
          isInspectorDeletion={false}
          isTaskDeletion={isTaskDeletion}
        />
      )}

      {openUpdateInspector && (
        <AssignInspector
          title="Update Inspector"
          isUpdateInspector={!!(taskList as TaskList[])[0]?.clerkId}
          openAssignInspector={openUpdateInspector}
          setOpenAssignInspector={setOpenUpdateInspector}
          fieldInspectorList={[
            {
              fieldInspectorName: 'Assigned To Me',
              fieldInspectorId: currentInspectorId,
            },
            ...JSON.parse(JSON.stringify(inspectorData)),
          ]}
          leadInspectorId={Number(getValueFromLocalStorage('inspectorId'))}
          inspectionId={inspectionID}
          taskList={taskList}
          inspectionLevelComment={inspectionLevelComment}
          isAssignToLead={isAssignToLead}
          taskId={taskId}
        />
      )}
      {offlineDialogBox && (
        <OfflineDialog open={offlineDialogBox} onClose={() => setOfflineDialogBox(false)} />
      )}
      {isOpenAdhocReAssignInspector && (
        <AdhocInspectionAssignment
          open={isOpenAdhocReAssignInspector}
          onClose={() => setIsOpenAdhocReAssignInspector(false)}
          taskId={taskId}
        />
      )}
    </>
  );
};
export default OnGoing;
